import axios from 'axios'
import router from './router'

export default() => {
    const unauthorized = 401;

    var authorization = 'Bearer ';

    if (localStorage.getItem('authenticationToken') !== null) {
        authorization += localStorage.authenticationToken;
    }

    const axiosInstance = axios.create({
        baseURL: window.apiBaseUrl,
        withCredentials: false,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': authorization,
        }
    });

    axiosInstance.interceptors.response.use(response => response, function (error) {
        // If the response has a 401, redirect to the login service
        if (error.response.status == unauthorized) {
            let comebackUrl = window.frontendUrl + router.history.current.path;
            window.location.replace(window.loginServiceUrl + '?redirect_url=' + comebackUrl);
            return;
        }

        return Promise.reject(error);
    });

    return axiosInstance;
}
